import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ExpandablePanel from '../../../../../../common/widgets/ExpandablePanel';
import Icons from '../../../../../../common/widgets/Icons';
import AdminMenu from '../../../../Pages/AdminAccount/Common/AdminMenu';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { CustomerPermissionsProvider } from '../../../../contexts/CustomerPermissionsContext';
import { resources } from '../../../../resources/resources';

interface IAccountProps {
  isTablet: boolean;
  closeMenu?: () => void;
}

export default function Admin(props: IAccountProps) {
  const { t: translate } = useTranslation();
  const { isTablet, closeMenu } = props;

  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <>
      {isTablet && customerInfo.isPowerUser && (
        <ExpandablePanel
          arrowType="downMobile"
          title={
            <Link
              to="/admin/attendance"
              onClick={() => closeMenu?.()}
              className="btn app-bar-tools-btn app-bar-admin-mobile app-bar-expand"
            >
              <span className="btn-icon">
                <Icons.Admin />
              </span>
              <span className="btn-text">
                {translate(resources.menu.admin)}
              </span>
            </Link>
          }
        >
          <CustomerPermissionsProvider>
            <AdminMenu menuClose={closeMenu} />
          </CustomerPermissionsProvider>
        </ExpandablePanel>
      )}
    </>
  );
}
